/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Article,
  ArticlesListParams,
  ArticlesRetrieve404,
  PaginatedArticleList
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Articles visible to the authenticated user's company. Includes broadcasts (no `target_companies`) and articles whose `target_companies` contains the user's company. Filter by category (REGULATION, GEOPOLITICS, BUSINESS_NEWS) if needed.
 * @summary List articles
 */
export const articlesList = (
    params?: ArticlesListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedArticleList>(
      {url: `/api/v1/articles/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getArticlesListQueryKey = (params?: ArticlesListParams,) => {
    return [`/api/v1/articles/`, ...(params ? [params]: [])] as const;
    }

    
export const getArticlesListQueryOptions = <TData = Awaited<ReturnType<typeof articlesList>>, TError = unknown>(params?: ArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof articlesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArticlesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof articlesList>>> = ({ signal }) => articlesList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof articlesList>>, TError, TData> & { queryKey: QueryKey }
}

export type ArticlesListQueryResult = NonNullable<Awaited<ReturnType<typeof articlesList>>>
export type ArticlesListQueryError = unknown

/**
 * @summary List articles
 */
export const useArticlesList = <TData = Awaited<ReturnType<typeof articlesList>>, TError = unknown>(
 params?: ArticlesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof articlesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getArticlesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get a specific article by ID. Returns 404 for articles targeted at other companies.
 * @summary Get article by ID
 */
export const articlesRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Article>(
      {url: `/api/v1/articles/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getArticlesRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/articles/${id}/`] as const;
    }

    
export const getArticlesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof articlesRetrieve>>, TError = ArticlesRetrieve404>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof articlesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArticlesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof articlesRetrieve>>> = ({ signal }) => articlesRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof articlesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ArticlesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof articlesRetrieve>>>
export type ArticlesRetrieveQueryError = ArticlesRetrieve404

/**
 * @summary Get article by ID
 */
export const useArticlesRetrieve = <TData = Awaited<ReturnType<typeof articlesRetrieve>>, TError = ArticlesRetrieve404>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof articlesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getArticlesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Bookmark this article for the authenticated user's company.
 * @summary Add article to my watchlist
 */
export const articlesWatchlistCreate = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/articles/${id}/watchlist/`, method: 'POST'
    },
      );
    }
  


export const getArticlesWatchlistCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof articlesWatchlistCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof articlesWatchlistCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof articlesWatchlistCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  articlesWatchlistCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArticlesWatchlistCreateMutationResult = NonNullable<Awaited<ReturnType<typeof articlesWatchlistCreate>>>
    
    export type ArticlesWatchlistCreateMutationError = void

    /**
 * @summary Add article to my watchlist
 */
export const useArticlesWatchlistCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof articlesWatchlistCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof articlesWatchlistCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getArticlesWatchlistCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Un-bookmark this article for the authenticated user's company.
 * @summary Remove article from my watchlist
 */
export const articlesWatchlistDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/articles/${id}/watchlist/`, method: 'DELETE'
    },
      );
    }
  


export const getArticlesWatchlistDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof articlesWatchlistDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof articlesWatchlistDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof articlesWatchlistDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  articlesWatchlistDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArticlesWatchlistDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof articlesWatchlistDestroy>>>
    
    export type ArticlesWatchlistDestroyMutationError = void

    /**
 * @summary Remove article from my watchlist
 */
export const useArticlesWatchlistDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof articlesWatchlistDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof articlesWatchlistDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getArticlesWatchlistDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Generate a clean, readable PDF with all articles visible to the authenticated user's company (broadcasts + articles targeted at it) that were added in the last 30 days.

Each article includes title, category, release date, source and brief.
 * @summary Download recent articles as PDF (last 30 days)
 */
export const articlesRecentExportPdfRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/articles/recent/exportPdf/`, method: 'GET', signal
    },
      );
    }
  

export const getArticlesRecentExportPdfRetrieveQueryKey = () => {
    return [`/api/v1/articles/recent/exportPdf/`] as const;
    }

    
export const getArticlesRecentExportPdfRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof articlesRecentExportPdfRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof articlesRecentExportPdfRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getArticlesRecentExportPdfRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof articlesRecentExportPdfRetrieve>>> = ({ signal }) => articlesRecentExportPdfRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof articlesRecentExportPdfRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ArticlesRecentExportPdfRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof articlesRecentExportPdfRetrieve>>>
export type ArticlesRecentExportPdfRetrieveQueryError = unknown

/**
 * @summary Download recent articles as PDF (last 30 days)
 */
export const useArticlesRecentExportPdfRetrieve = <TData = Awaited<ReturnType<typeof articlesRecentExportPdfRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof articlesRecentExportPdfRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getArticlesRecentExportPdfRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



